import _ from "lodash";
import { computed } from "mobx";
import { useMemo } from "react";
import { usePipedriveStore } from "..";

export default function (ownerFilter: string, searchFilter: string, sortBy: string) {
    const pipedriveStore = usePipedriveStore();

    const ownerFilteredDeals = useMemo(() => computed(() => {
        switch (ownerFilter) {
            case "All Owners":
                return pipedriveStore.deals;
            default:
                return pipedriveStore.deals.filter(d => pipedriveStore.users.find(u => u.id === d.assignedToUserId)!.name === ownerFilter);
        }
    }), [ownerFilter]).get();

    const sortedDeals = useMemo(() => computed(() => {
        switch (sortBy) {
            case DealsSortingType.NameAlphabet:
                return _.orderBy(ownerFilteredDeals, deal => deal.name, "asc");
            case DealsSortingType.NameReverseAlphabet:
                return _.orderBy(ownerFilteredDeals, deal => deal.name, "desc");
            case DealsSortingType.PriceLowToHigh:
                return _.orderBy(ownerFilteredDeals, deal => deal.value, "asc");
            case DealsSortingType.PriceHighToLow:
                return _.orderBy(ownerFilteredDeals, deal => deal.value, "desc");
            case DealsSortingType.CreatedNewest:
                return _.orderBy(ownerFilteredDeals, deal => deal.createdAt, "desc");
            case DealsSortingType.CreatedOldest:
                return _.orderBy(ownerFilteredDeals, deal => deal.createdAt, "asc");
            case DealsSortingType.ModifiedNewest:
                return _.orderBy(ownerFilteredDeals, deal => deal.updatedAt || deal.createdAt, "desc");
            case DealsSortingType.ModifiedOldest:
                return _.orderBy(ownerFilteredDeals, deal => deal.updatedAt || deal.createdAt, "asc");
            case DealsSortingType.StageEarliest:
                return _.orderBy(ownerFilteredDeals, deal => pipedriveStore.dealStages.find(s => s.id === deal.dealStageId)!.order, "asc");
            case DealsSortingType.StageLatest:
                return _.orderBy(ownerFilteredDeals, deal => pipedriveStore.dealStages.find(s => s.id === deal.dealStageId)!.order, "desc");
            default:
                return _.orderBy(ownerFilteredDeals, deal => deal.createdAt, "asc");
        }
    }), [ownerFilteredDeals, sortBy]).get();

    return useMemo(() => {
        if (!searchFilter)
            return sortedDeals;

        const searchFilterInLowerCase = searchFilter.toLowerCase();

        return sortedDeals.filter(d =>
            d.name && d.name.toLowerCase().includes(searchFilterInLowerCase)
        );
    }, [sortedDeals, searchFilter]);
}

export class DealsSortingType {
    static NameAlphabet = "NameAlphabet";
    static NameReverseAlphabet = "NameReverseAlphabet";
    static PriceLowToHigh = "PriceLowToHigh";
    static PriceHighToLow = "PriceHighToLow";
    static CreatedNewest = "CreatedNewest";
    static CreatedOldest = "CreatedOldest";
    static ModifiedNewest = "ModifiedNewest";
    static ModifiedOldest = "ModifiedOldest";
    static StageEarliest = "StageEarliest";
    static StageLatest = "StageLatest";
}